<template>
  <dashboard-layout :loading="!sessionsLoaded" loading-text="正在打开聊天">
    <div class="chat-page">
      <aside class="sessions">
        <div class="search-row">
          <el-input v-model="kw" prefix-icon="el-icon-search" placeholder="搜索伴侣或聊天" size="small" />
          <el-button type="primary" icon="el-icon-plus" circle size="small" title="创建新伴侣" @click="$router.push('/companion-editor')" />
        </div>
        <div v-if="!filteredSessions.length" class="empty-sess">
          <p>没有伴侣</p>
          <el-button type="primary" size="small" round @click="$router.push('/companion-editor')">去创建伴侣</el-button>
        </div>
        <div
          v-for="s in filteredSessions"
          :key="s.id"
          class="session"
          :class="{ active: s.id === current.id }"
          @click="switchSession(s)"
        >
          <img :src="s.avatar || require('@/assert/主页人物.png')" alt="" class="av" />
          <div class="info">
            <div class="top">
              <b>{{ s.name }}</b>
              <span class="tag" :class="{ off: s.status !== '在线' }">{{ s.status }}</span>
              <em>{{ s.time }}</em>
            </div>
            <p>{{ s.lastMessage }}</p>
          </div>
        </div>
        <el-button class="manage" round @click="$router.push('/companions')">管理伴侣</el-button>
      </aside>

      <section v-if="hasNoCompanions" class="main-chat empty-chat">
        <div class="empty-chat-inner">
          <i class="el-icon-user"></i>
          <h2>没有伴侣</h2>
          <p>创建一个伴侣后，就可以在这里开始聊天、绑定微信和生成照片。</p>
          <div class="empty-actions">
            <el-button type="primary" round @click="$router.push('/companion-editor')">创建伴侣</el-button>
            <el-button round @click="$router.push('/role-cards')">先看看角色卡</el-button>
          </div>
        </div>
      </section>

      <section v-else class="main-chat">
        <header class="chat-head">
          <img :src="current.avatar || require('@/assert/主页人物.png')" alt="" class="av" />
          <div class="meta">
            <div class="name-row">
              <b>{{ current.name }}</b>
              <span class="online">● {{ current.status }}</span>
            </div>
            <p>{{ current.lastMessage }}</p>
          </div>
          <div class="tools">
            <label class="wx-push" :class="{ on: pushToWx }" title="开启后，网页对话会实时同步推送到微信">
              <i class="el-icon-chat-round"></i>
              <span>同步到微信</span>
              <el-switch v-model="pushToWx" active-color="#07c160" @change="onTogglePush" />
            </label>
            <i class="el-icon-search" :class="{ active: searchVisible }" title="搜索聊天记录" @click="toggleSearch"></i>
            <el-dropdown trigger="click" @command="onHeadCommand">
              <i class="el-icon-more"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="detail"><i class="el-icon-user"></i> 查看伴侣详情</el-dropdown-item>
                <el-dropdown-item command="sync"><i class="el-icon-refresh"></i> 立即同步微信记录</el-dropdown-item>
                <el-dropdown-item command="reset"><i class="el-icon-refresh-left"></i> 清空会话记忆</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </header>
        <div v-if="chatSessions.length > 1 || sessionKey" class="session-tabs">
          <span
            v-for="cs in chatSessions"
            :key="cs.key || 'default'"
            class="session-tab"
            :class="{ on: cs.key === sessionKey }"
            @click="switchChatSession(cs.key)"
          >
            {{ cs.key ? cs.display_name : "主会话" }}
            <i v-if="cs.key" class="el-icon-close" @click.stop="removeChatSession(cs)"></i>
          </span>
          <span class="session-tab add" @click="createChatSession"><i class="el-icon-plus"></i> 新会话</span>
        </div>
        <div v-else class="session-tabs single">
          <span class="session-tab add" @click="createChatSession"><i class="el-icon-plus"></i> 开个新话题（不影响主会话记忆）</span>
        </div>
        <div v-if="searchVisible" class="msg-search">
          <el-input v-model="msgKeyword" prefix-icon="el-icon-search" placeholder="在当前对话中搜索…" size="small" clearable />
          <span class="cnt">{{ messages.length }} 条</span>
        </div>
        <div class="messages" ref="msgBox">
          <div v-if="historyLoading" class="history-loading"><i class="el-icon-loading"></i> 正在加载聊天记录</div>
          <div v-else-if="!messages.length" class="empty-msg">还没有聊天记录，发条消息开始吧～</div>
          <div v-for="m in messages" :key="m.id" class="row" :class="m.role">
            <img v-if="m.role === 'ai'" :src="current.avatar || require('@/assert/主页人物.png')" alt="" class="av" />
            <div class="msg-wrap">
              <span v-if="m.actor" class="actor"><i class="el-icon-user"></i> {{ m.actor }}</span>
              <div class="bubble" :class="{ 'has-image': m.images && m.images.length }">
                <div v-if="m.images && m.images.length" class="bubble-media">
                  <img v-for="(img, idx) in m.images" :key="img + ':' + idx" :src="img" class="bubble-img" alt="" />
                </div>
                <div v-if="m.text" class="bubble-text">
                  <i v-if="!m.images.length && m.type === 'image'" class="el-icon-picture"></i>
                  <i v-else-if="m.type === 'voice'" class="el-icon-microphone"></i>
                  {{ m.text }}
                </div>
              </div>
              <small v-if="m.role === 'ai' && m.deliveryLabel" class="delivery-label">{{ m.deliveryLabel }}</small>
            </div>
            <span v-if="m.role === 'user'" class="av user-av">我</span>
          </div>
          <div v-if="sending || mediaProcessing" class="typing">
            {{ sending ? current.name + "正在输入..." : current.name + "正在处理图片..." }}
          </div>
        </div>
        <footer class="input-area">
          <div class="toolbar">
            <el-popover placement="top-start" trigger="click" popper-class="emoji-popover">
              <div class="emoji-grid">
                <span v-for="e in emojis" :key="e" class="emoji" @click="draft += e">{{ e }}</span>
              </div>
              <i slot="reference" class="el-icon-orange" title="表情"></i>
            </el-popover>
            <i class="el-icon-picture-outline" title="发送图片" @click="imageVisible = true"></i>
            <i class="el-icon-microphone" title="发消息（TA 可语音回复）" @click="voiceVisible = true"></i>
          </div>
          <el-input v-model="draft" type="textarea" :rows="2" :placeholder="'输入消息，和' + current.name + '聊聊吧~'" resize="none" @keyup.enter.native="send" />
          <el-button type="primary" icon="el-icon-s-promotion" circle class="send" @click="send" />
        </footer>
      </section>

      <aside v-if="!hasNoCompanions" class="side-panel">
        <h3>♥ 温暖陪伴中</h3>
        <div class="stat">
          <label>亲密度</label>
          <el-progress :percentage="current.intimacy || 0" :show-text="false" color="#c94225" />
          <span>{{ current.intimacy || 0 }}/100 · {{ current.relation || "初识" }}</span>
        </div>
        <div class="stat-row">
          <div><b>{{ current.days || 0 }}</b><small>陪伴天数</small></div>
          <div><b>{{ current.localTime || "—" }}</b><small>所在地时间</small></div>
        </div>
        <div class="block">
          <div class="block-head">快速回忆 <a @click="$router.push({ path: '/companion-detail', query: { id: current.id } })">查看全部</a></div>
          <div class="memory">
            <span class="dot"></span>
            <div><p>聊得越多，{{ current.name }}记得越多。<a @click="$router.push({ path: '/companion-detail', query: { id: current.id } })">查看长期记忆 ></a></p></div>
          </div>
        </div>
        <div class="block">
          <div class="block-head">此刻的状态</div>
          <div class="now-state">
            <p>{{ currentStateSummary }}</p>
          </div>
        </div>
        <div class="block">
          <div class="block-head">快捷操作</div>
          <div class="quick-grid">
            <button @click="quickAction('morning')">发送早安问候</button>
            <button @click="quickAction('memory')">记录一段回忆</button>
            <button @click="quickAction('portrait')">生成专属画像</button>
            <button @click="quickAction('mood')">分享心情卡片</button>
          </div>
        </div>
      </aside>
    </div>

    <!-- 发送图片 -->
    <el-dialog title="发送图片" :visible.sync="imageVisible" width="420px" custom-class="yw-dialog">
      <el-upload drag action="#" :show-file-list="false" accept="image/*" :before-upload="onPickImage" class="chat-upload">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽图片到此处<br />支持 JPG / PNG / WebP，最大 12MB</div>
      </el-upload>
      <span slot="footer">
        <el-button round @click="imageVisible = false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 发消息（网页端暂不支持你这边语音录入，诚实化为文字输入；TA 可用语音回复） -->
    <el-dialog title="发消息（TA 可语音回你）" :visible.sync="voiceVisible" width="400px" custom-class="yw-dialog">
      <el-input v-model="voiceText" type="textarea" :rows="3" placeholder="打字发给 TA 就好~" />
      <p class="voice-tip">网页端暂不支持你这边语音录入，请打字发送；TA 可以用语音（edge-tts）回复你。</p>
      <span slot="footer">
        <el-button round @click="voiceVisible = false">取消</el-button>
        <el-button type="primary" round @click="sendVoiceText">发送</el-button>
      </span>
    </el-dialog>
  </dashboard-layout>
</template>

<script>
import { companionApi, roleCardApi } from "@/services/api";
import DashboardLayout from "@/components/DashboardLayout.vue";

const PUSH_KEY = "xyo_push_wx";
const SYNC_INTERVAL = 4000;

export default {
  name: "ChatView",
  components: { DashboardLayout },
  data() {
    return {
      kw: "",
      draft: "",
      sessions: [],
      sessionsLoaded: false,
      webMessages: [],
      current: { id: "", name: "伴侣", status: "", lastMessage: "", avatar: "", intimacy: 0, relation: "", days: 0 },
      sessionId: "",
      sessionKey: "",
      chatSessions: [],
      sending: false,
      pendingUserText: "",
      pendingTurnId: "",
      pendingMediaTurnIds: [],
      // 每次切换角色/会话递增；异步回包若 token 不匹配则丢弃，避免 A 的回复写进 B
      chatViewToken: 0,
      snapshotRequestSeq: 0,
      appliedSnapshotRequestSeq: 0,
      appliedResolutionToken: "",
      imageVisible: false,
      voiceVisible: false,
      emojis: ["😊", "😘", "🥰", "😍", "😄", "🤭", "😉", "😋", "🤗", "😎", "🥺", "😢", "😡", "😴", "🤔", "😮", "👍", "👋", "🙏", "💪", "❤️", "💕", "💖", "🌹", "🎉", "✨", "🌙", "☀️", "🍰", "🐱"],
      voiceText: "",
      pushToWx: true,
      hasWechat: false,
      syncTimer: null,
      searchVisible: false,
      msgKeyword: "",
      historyLoading: false,
    };
  },
  computed: {
    filteredSessions() {
      const kw = this.kw.trim().toLowerCase();
      if (!kw) return this.sessions;
      return this.sessions.filter((s) => s.name.toLowerCase().includes(kw));
    },
    hasNoCompanions() {
      return this.sessionsLoaded && this.sessions.length === 0;
    },
    mediaProcessing() {
      return this.pendingMediaTurnIds.length > 0;
    },
    messages() {
      let arr = [...this.webMessages].sort((a, b) => a.ts - b.ts || a.seq - b.seq);
      const kw = this.msgKeyword.trim().toLowerCase();
      if (kw) arr = arr.filter((m) => (m.text || "").toLowerCase().includes(kw));
      return arr;
    },
    currentStateSummary() {
      const clean = (value) => String(value || "").trim().replace(/[，。；;、\s]+$/, "");
      const location = clean(this.current.currentLocation);
      const activity = clean(this.current.activity);
      const mood = clean(this.current.todayStatus);
      const weather = clean(this.current.weather);
      const outfit = clean(this.current.outfit);
      const hasEnergy = this.current.energy !== undefined && this.current.energy !== null && this.current.energy !== "";
      const energy = Number(this.current.energy);
      const sentences = [];

      if (location && activity) sentences.push(`现在在${location}，${activity}`);
      else if (location) sentences.push(`现在在${location}，手头的事情还没细说`);
      else if (activity) sentences.push(`现在${activity}`);
      else sentences.push("现在正在忙自己的事，具体细节还没有展开");

      const surroundings = [];
      if (weather) surroundings.push(`当地天气${weather}`);
      if (outfit) surroundings.push(`今天穿着${outfit}`);
      if (surroundings.length) sentences.push(surroundings.join("，"));

      const feeling = [];
      if (mood) feeling.push(`心情是${mood}`);
      if (hasEnergy && Number.isFinite(energy)) feeling.push(`精力大约 ${energy}/100`);
      if (feeling.length) sentences.push(feeling.join("，"));

      return `${sentences.join("。")}。`;
    },
  },
  created() {
    this.loadSessions();
  },
  beforeDestroy() {
    this.stopSync();
  },
  methods: {
    toTs(s) {
      const t = Date.parse(s || "");
      return Number.isNaN(t) ? 0 : t;
    },
    messageRenderSignature(messages) {
      // 时间线固定返回最新 500 条。超过上限后每新增一条都会同时挤掉最旧一条，
      // 因此“列表长度 + 最后一项”可能完全不变；必须比较实际渲染字段。
      return JSON.stringify((messages || []).map((item) => [
        String(item.id || ""),
        String(item.unitId || ""),
        Number(item.seq || 0),
        Number(item.ts || 0),
        String(item.role || ""),
        String(item.type || ""),
        String(item.text || ""),
        Array.isArray(item.images) ? item.images : [],
        String(item.deliveryState || ""),
        String(item.deliveryLabel || ""),
      ]));
    },
    scrollBottom() {
      this.$nextTick(() => {
        const box = this.$refs.msgBox;
        if (box) box.scrollTop = box.scrollHeight;
      });
    },
    applySnapshot(snapshot, requestSeq) {
      const state = snapshot && snapshot.state;
      if (!state || !this.current.id) return;
      if (requestSeq < this.appliedSnapshotRequestSeq) return;
      const token = String(snapshot.resolution_token || state.resolution_token || "");
      if (
        requestSeq === this.appliedSnapshotRequestSeq &&
        this.appliedResolutionToken &&
        token !== this.appliedResolutionToken
      ) return;
      this.appliedSnapshotRequestSeq = requestSeq;
      this.appliedResolutionToken = token;
      if (state.relationship_temperature !== undefined && state.relationship_temperature !== null) {
        this.current.intimacy = state.relationship_temperature;
      }
      if (state.relationship_stage) this.current.relation = state.relationship_stage;
      if (state.mood) this.current.todayStatus = state.mood;
      this.current.currentLocation = state.current_location || "";
      this.current.activity = state.current_activity || "";
      if (state.outfit) this.current.outfit = state.outfit;
      if (state.energy !== undefined && state.energy !== null) this.current.energy = Number(state.energy);
    },
    async loadSessions() {
      try {
        const [list, roleCards] = await Promise.all([
          companionApi.list(),
          roleCardApi.list().catch(() => []),
        ]);
        const roleCardMap = new Map((roleCards || []).map((rc) => [rc.id, rc]));
        this.sessions = (list || []).map((c) => {
          const p = c.presentation || {};
          const weather = p.weather || {};
          return {
            id: c.id,
            name: c.name,
            status: c.binding_status === "bound" ? "在线" : "未绑定",
            lastMessage: c.welcome_message || c.description || "开始聊天吧～",
            time: "",
            avatar: (roleCardMap.get(c.role_card_id) || {}).reference_image_url || "",
            intimacy: p.intimacy !== null && p.intimacy !== undefined
              ? p.intimacy
              : (c.intimacy_base_level || 0),
            relation: p.relationship_label || "",
            days: p.interaction_days || 0,
            localTime: p.local_time || "",
            todayStatus: p.today_status || "",
            weather: weather.summary || "",
            outfit: p.outfit || "",
            currentLocation: p.current_location || "",
            activity: p.current_activity || "",
            energy: Number.isFinite(Number(p.energy)) ? Number(p.energy) : null,
            webToWeixin: p.web_to_weixin !== false,
          };
        });
        if (!this.sessions.length) {
          this.current = { id: "", name: "", status: "", lastMessage: "" };
          return;
        }
        const qid = this.$route.query.id;
        const target = this.sessions.find((s) => String(s.id) === String(qid)) || this.sessions[0];
        await this.switchSession(target);
      } catch (e) {
        this.$message.warning("加载会话失败");
      } finally {
        this.sessionsLoaded = true;
      }
    },
    mapHistory(history) {
      return (history || [])
        .map((m, i) => {
          const origin = String(m.content_origin || (m.role === "user" ? "user" : m.role === "system" ? "system" : "companion"));
          const source = String(m.source || (m.role === "assistant" ? "web" : "web")).toLowerCase();
          const via = source === "wechat" ? "wechat" : source === "system" ? "system" : "web";
          const actor = origin === "system" ? "系统" : via === "wechat" ? "微信" : "网页";
          const deliveryState = String(m.delivery_state || "");
          const deliveryLabel = deliveryState === "provider_accepted"
            ? "已提交渠道·送达未确认"
            : deliveryState === "delivery_unconfirmed"
              ? "送达状态未确认"
              : "";
          const mediaUrl = String(m.media_url || "").trim();
          const legacyImages = Array.isArray(m.images) ? m.images.filter(Boolean) : [];
          const images = mediaUrl && (m.kind === "image" || m.type === "image") ? [mediaUrl] : legacyImages;
          return {
            id: m.id || `${via}:${i}`,
            unitId: String(m.unit_id || ""),
            via,
            actor,
            seq: Number.isFinite(m.timeline_seq) ? m.timeline_seq : i,
            ts: this.toTs(m.occurred_at || m.updated_at) || i,
            role: origin === "user" ? "user" : origin === "system" ? "system" : "ai",
            contentOrigin: origin,
            deliveryState,
            deliveryLabel,
            text: m.text !== undefined ? m.text : m.content,
            type: m.kind || (images.length ? "image" : "text"),
            image: images.length ? images[0] : "",
            images,
          };
        });
    },
    activeDeliveryStatuses(statuses) {
      const active = (statuses || []).filter((item) => item.status !== "resolved");
      // 同一轮已有 Effect/投递单元的具体失败时，Turn 级通用兜底只会重复报错。
      const specificallyFailedTurns = new Set(
        active
          .filter((item) => item.status === "failed" && item.target_kind !== "turn" && item.turn_id)
          .map((item) => String(item.turn_id))
      );
      return active.filter((item) => {
        // Effect 级媒体失败是机器可读状态，只供管理面和评测消费。
        // 聊天区由 companion 补偿消息承接，不能再画 system notice 或 deliveryLabel。
        if (["effect", "turn_failure_handled"].includes(item.target_kind)) return false;
        return !(
          item.status === "failed" &&
          item.target_kind === "turn" &&
          specificallyFailedTurns.has(String(item.turn_id || ""))
        );
      });
    },
    mapDeliveryStatuses(statuses) {
      return this.activeDeliveryStatuses(statuses).map((item, i) => ({
        id: `status:${item.id || i}`,
        turnId: String(item.turn_id || ""),
        targetKind: String(item.target_kind || ""),
        publicCode: String(item.public_code || ""),
        via: "system",
        actor: "系统",
        seq: Number.MAX_SAFE_INTEGER - 1000 + i,
        // 状态对账会更新 updated_at；展示位置必须固定在事故首次发生时间，
        // 否则昨天的失败会在 24 小时回执超时后被顶成今天的新消息。
        ts: this.toTs(item.created_at || item.updated_at) || i,
        role: "system",
        contentOrigin: "system",
        deliveryState: String(item.delivery_state || "local"),
        deliveryLabel: "",
        text: item.public_message || "消息状态已更新",
        type: "notice",
        image: "",
        images: [],
      }));
    },
    mergeDeliveryStatuses(messages, statuses) {
      const mapped = [...(messages || [])];
      const activeStatuses = this.activeDeliveryStatuses(statuses);
      const byUnit = new Map(
        mapped.filter((item) => item.unitId).map((item) => [item.unitId, item])
      );
      const unmatched = [];
      activeStatuses.forEach((item) => {
        const targetUnit = String(
          item.target_kind === "delivery_unit" ? item.target_id : item.unit_id || ""
        );
        const target = targetUnit ? byUnit.get(targetUnit) : null;
        if (target) {
          target.deliveryState = String(item.delivery_state || target.deliveryState || "");
          target.deliveryLabel = item.public_message || target.deliveryLabel || "消息状态已更新";
          return;
        }
        unmatched.push(item);
      });
      return mapped.concat(this.mapDeliveryStatuses(unmatched));
    },
    isChatViewCurrent(token, companionId, sessionKey) {
      return (
        token === this.chatViewToken &&
        String(this.current.id) === String(companionId) &&
        String(this.sessionKey || "") === String(sessionKey || "")
      );
    },
    beginChatView(companion) {
      this.stopSync();
      this.chatViewToken += 1;
      this.sending = false;
      this.pendingUserText = "";
      this.pendingTurnId = "";
      this.pendingMediaTurnIds = [];
      this.current = companion;
      this.sessionKey = "";
      this.chatSessions = [];
      this.webMessages = [];
      return this.chatViewToken;
    },
    async switchSession(s) {
      const token = this.beginChatView(s);
      this.loadChatSessions(s.id, token);
      this.probeWechat(s.id, token);
      await this.loadChatHistory(token);
      if (!this.isChatViewCurrent(token, s.id, "")) return;
      this.startSync();
      this.scrollBottom();
    },
    async probeWechat(companionId, token = this.chatViewToken) {
      try {
        const view = await companionApi.wechatSync(companionId, -1, 1);
        if (!this.isChatViewCurrent(token, companionId, this.sessionKey)) return;
        this.hasWechat = !!view.has_wechat;
      } catch (e) {
        if (!this.isChatViewCurrent(token, companionId, this.sessionKey)) return;
        this.hasWechat = false;
      }
    },
    async loadChatSessions(companionId, token = this.chatViewToken) {
      try {
        const list = (await companionApi.chatSessions(companionId)) || [];
        if (!this.isChatViewCurrent(token, companionId, this.sessionKey)) return;
        this.chatSessions = list;
      } catch (e) {
        if (!this.isChatViewCurrent(token, companionId, this.sessionKey)) return;
        this.chatSessions = [];
      }
    },
    async loadChatHistory(token = this.chatViewToken) {
      const companionId = this.current.id;
      const sessionKey = this.sessionKey;
      const welcome = this.current.lastMessage;
      this.historyLoading = true;
      this.webMessages = [];
      this.pushToWx = this.loadPushPref(companionId, this.current.webToWeixin !== false);
      const snapshotRequestSeq = ++this.snapshotRequestSeq;
      try {
        const view = await companionApi.chat(companionId, sessionKey);
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        this.applySnapshot(view.state_snapshot, snapshotRequestSeq);
        this.sessionId = view.session_id;
        this.webMessages = this.mergeDeliveryStatuses(
          this.mapHistory(view.messages || view.history),
          view.delivery_statuses
        );
        if (!this.webMessages.length && welcome) {
          this.webMessages.push({ id: "welcome", via: "web", seq: 0, ts: 0, role: "ai", text: welcome, type: "text", image: "", images: [] });
        }
      } catch (e) {
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        this.$message.warning("加载聊天记录失败");
      } finally {
        if (this.isChatViewCurrent(token, companionId, sessionKey)) {
          this.historyLoading = false;
        }
      }
    },
    async switchChatSession(key) {
      if (key === this.sessionKey) return;
      this.stopSync();
      this.chatViewToken += 1;
      const token = this.chatViewToken;
      this.sending = false;
      this.pendingUserText = "";
      this.pendingTurnId = "";
      this.pendingMediaTurnIds = [];
      this.sessionKey = key;
      this.webMessages = [];
      await this.loadChatHistory(token);
      if (!this.isChatViewCurrent(token, this.current.id, key)) return;
      this.startSync();
      this.scrollBottom();
    },
    createChatSession() {
      if (!this.current.id) return;
      this.$prompt("给新会话起个名字（独立记忆，不影响主会话）", "新会话", {
        confirmButtonText: "创建",
        cancelButtonText: "取消",
        inputValue: "新话题",
      })
        .then(async ({ value }) => {
          try {
            const created = await companionApi.createChatSession(this.current.id, (value || "").trim() || "新话题");
            await this.loadChatSessions(this.current.id);
            await this.switchChatSession(created.key);
          } catch (e) {
            this.$message.error(e.message || "创建会话失败");
          }
        })
        .catch(() => {});
    },
    removeChatSession(cs) {
      this.$confirm(`删除会话「${cs.display_name}」会清空它的聊天记录和记忆，确定吗？`, "删除会话", { type: "warning" })
        .then(async () => {
          try {
            await companionApi.removeChatSession(this.current.id, cs.key);
            if (this.sessionKey === cs.key) {
              await this.switchChatSession("");
            }
            await this.loadChatSessions(this.current.id);
            this.$message.success("已删除");
          } catch (e) {
            this.$message.error(e.message || "删除失败");
          }
        })
        .catch(() => {});
    },
    isLocalOnlyMessage(m) {
      const id = String((m && m.id) || "");
      return id.startsWith("tmp:") || id.startsWith("err") || id === "welcome";
    },
    waitableImageJobs(status) {
      const terminal = new Set(["succeeded", "failed", "cancelled", "unknown"]);
      return (Array.isArray(status && status.media_jobs) ? status.media_jobs : []).filter(
        (item) => item && item.kind === "image" && !terminal.has(String(item.status || ""))
      );
    },
    setMediaTurnPending(turnId, pending) {
      const id = String(turnId || "");
      if (!id) return;
      const ids = this.pendingMediaTurnIds.filter((item) => item !== id);
      if (pending) ids.push(id);
      this.pendingMediaTurnIds = ids;
    },
    async refreshTurnMediaStatus(turnId, token, companionId, sessionKey) {
      const status = await companionApi.turn(companionId, turnId);
      if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
      if (String(status.state || "") !== "terminal") return;
      this.setMediaTurnPending(turnId, this.waitableImageJobs(status).length > 0);
      if (this.pendingTurnId === turnId) {
        this.sending = false;
        this.pendingTurnId = "";
        this.pendingUserText = "";
      }
    },
    async refreshPendingMediaStatuses(token, companionId, sessionKey) {
      const ids = [...this.pendingMediaTurnIds];
      await Promise.all(
        ids.map((turnId) =>
          this.refreshTurnMediaStatus(turnId, token, companionId, sessionKey).catch(() => {})
        )
      );
    },
    async pollChat() {
      if (!this.current.id) return;
      const token = this.chatViewToken;
      const companionId = this.current.id;
      const sessionKey = this.sessionKey;
      const snapshotRequestSeq = ++this.snapshotRequestSeq;
      try {
        const view = await companionApi.chat(companionId, sessionKey);
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        this.applySnapshot(view.state_snapshot, snapshotRequestSeq);
        const mapped = this.mergeDeliveryStatuses(
          this.mapHistory(view.messages || view.history),
          view.delivery_statuses
        );
        const activeTurns = Array.isArray(view.turns) ? view.turns : [];
        await this.refreshPendingMediaStatuses(token, companionId, sessionKey);
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        if (this.pendingTurnId && !activeTurns.some((item) => item.turn_id === this.pendingTurnId)) {
          await this.refreshTurnMediaStatus(this.pendingTurnId, token, companionId, sessionKey);
          if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        }
        if (!mapped.length) return;
        if (this.sending) {
          // 发送期间只有服务端历史已包含本条消息（生图前的垫场回复场景）才刷新，避免乐观消息闪烁
          const pending = this.pendingUserText;
          if (!pending || !mapped.some((m) => m.role === "user" && m.text === pending)) return;
        }
        // 额度拦截等本地提示不在服务端历史里，同步时要保留，否则气泡会闪一下消失
        const localOnly = this.webMessages.filter((m) => this.isLocalOnlyMessage(m));
        const existingTexts = new Set(mapped.map((m) => String(m.text || "").trim()).filter(Boolean));
        const keepLocal = localOnly.filter((m) => {
          const body = String(m.text || "").trim();
          if (m.role === "user" && body && mapped.some((x) => x.role === "user" && String(x.text || "").trim() === body)) {
            return false;
          }
          return !body || !existingTexts.has(body);
        });
        const next = keepLocal.length ? mapped.concat(keepLocal) : mapped;
        if (this.messageRenderSignature(next) !== this.messageRenderSignature(this.webMessages)) {
          this.webMessages = next;
          this.scrollBottom();
        }
      } catch (e) {
        /* 静默：心跳同步失败不打扰用户 */
      }
    },
    startSync() {
      this.stopSync();
      this.syncTimer = setInterval(() => this.pollChat(), SYNC_INTERVAL);
    },
    stopSync() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer);
        this.syncTimer = null;
      }
    },
    loadPushPref(companionId, defaultValue = true) {
      try {
        const map = JSON.parse(localStorage.getItem(PUSH_KEY) || "{}");
        return Object.prototype.hasOwnProperty.call(map, companionId) ? map[companionId] !== false : defaultValue !== false;
      } catch (e) {
        return defaultValue !== false;
      }
    },
    onTogglePush(val) {
      try {
        const map = JSON.parse(localStorage.getItem(PUSH_KEY) || "{}");
        map[this.current.id] = val;
        localStorage.setItem(PUSH_KEY, JSON.stringify(map));
      } catch (e) {
        /* ignore */
      }
      if (val && !this.hasWechat) {
        this.$message.warning("该伴侣还没有微信会话，需对方先在微信上发起对话才能收到推送");
      } else if (val) {
        this.$message.success("已开启：网页对话将实时同步到微信");
      }
    },
    async send(imageUrl) {
      const text = this.draft.trim();
      const img = typeof imageUrl === "string" ? imageUrl : "";
      // 不因上一轮回复未结束而拦截发送：服务端有 1.5s 合并窗口与轮次改写机制，
      // 连发的消息会被合并成一轮统一回复。
      if ((!text && !img) || !this.current.id) return;
      const companionId = this.current.id;
      const sessionKey = this.sessionKey;
      const token = this.chatViewToken;
      const pushToWx = this.pushToWx && !sessionKey;
      const now = Date.now();
      const sourceMessageId =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? `web:${window.crypto.randomUUID()}`
          : `web:${now}:${Math.random().toString(16).slice(2)}`;
      this.webMessages.push({
        id: "tmp:" + now,
        via: "web",
        seq: 1e9,
        ts: now,
        role: "user",
        text,
        type: img ? "image" : "text",
        image: img,
        images: img ? [img] : [],
      });
      this.draft = "";
      this.sending = true;
      this.pendingUserText = text;
      this.scrollBottom();
      try {
        const accepted = await companionApi.sendChat(
          companionId,
          text,
          img,
          pushToWx,
          sessionKey,
          sourceMessageId
        );
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        this.pendingTurnId = accepted.turn_id || "";
        await this.pollChat();
        this.scrollBottom();
      } catch (e) {
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return;
        this.webMessages.push({
          id: "err" + now,
          via: "web",
          seq: 1e9,
          ts: now,
          role: "ai",
          text: "（消息发送失败：" + e.message + "）",
          type: "text",
          image: "",
          images: [],
        });
        this.sending = false;
        this.pendingTurnId = "";
        this.pendingUserText = "";
      }
    },
    sendVoiceText() {
      const t = (this.voiceText || "").trim();
      if (!t) {
        this.$message.warning("请输入要发送的内容");
        return;
      }
      this.draft = t;
      this.voiceText = "";
      this.voiceVisible = false;
      this.send();
    },
    async onPickImage(file) {
      if (!this.current.id) return false;
      const companionId = this.current.id;
      const sessionKey = this.sessionKey;
      const token = this.chatViewToken;
      this.imageVisible = false;
      this.sending = true;
      try {
        const res = await companionApi.uploadChatImage(companionId, file);
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return false;
        this.sending = false;
        await this.send(res.url);
      } catch (e) {
        if (!this.isChatViewCurrent(token, companionId, sessionKey)) return false;
        this.sending = false;
        this.$message.error(e.message || "图片上传失败");
      }
      return false;
    },
    toggleSearch() {
      this.searchVisible = !this.searchVisible;
      if (!this.searchVisible) this.msgKeyword = "";
    },
    quickAction(kind) {
      if (!this.current.id) return;
      if (kind === "morning") {
        this.draft = "早安呀~ 今天也要元气满满哦☀️";
        this.send();
      } else if (kind === "portrait") {
        this.draft = "帮我生成一张你现在的专属画像吧～";
        this.send();
      } else if (kind === "mood") {
        this.draft = "用一句话分享一下你此刻的心情吧～";
        this.send();
      } else if (kind === "memory") {
        this.$prompt("记录一段你们的回忆", "记录回忆", { confirmButtonText: "记录", cancelButtonText: "取消" })
          .then(({ value }) => {
            const v = (value || "").trim();
            if (!v) return;
            this.draft = "记住这件事：" + v;
            this.send();
          })
          .catch(() => {});
      }
    },
    onHeadCommand(cmd) {
      if (cmd === "detail") {
        this.$router.push({ path: "/companion-detail", query: { id: this.current.id } });
      } else if (cmd === "sync") {
        this.pollChat().then(() => {
          this.$message[this.hasWechat ? "success" : "info"](this.hasWechat ? "已同步最新记录" : "该伴侣暂无微信会话");
        });
      } else if (cmd === "reset") {
        this.$confirm(
          "清空后TA将不再记得此前聊过的内容（聊天记录仍会保留在页面上），确定继续吗？",
          "清空会话记忆",
          { type: "warning" }
        )
          .then(async () => {
            try {
              await companionApi.resetMemory(this.current.id, this.sessionId);
              this.$message.success("已清空会话记忆：TA不再记得之前的内容，聊天记录仍保留");
            } catch (e) {
              this.$message.error(e.message || "清空失败");
            }
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped lang="scss">
.chat-page {
  display: flex;
  gap: 16px;
  height: calc(100vh - 84px);

  .sessions {
    width: 260px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 20px;
    background: #fff;
    box-sizing: border-box;

    .search-row {
      display: flex;
      gap: 8px;
      margin-bottom: 14px;

      .el-input {
        flex: 1;
      }

      ::v-deep .el-input__inner {
        border-radius: 20px;
        border-color: #e8e3ed;
      }

      .el-button {
        border: 0;
        background: linear-gradient(90deg, #c94225, #7255e9);
      }
    }

    .empty-sess {
      padding: 30px 0;
      text-align: center;
      color: #bbb;
      font-size: 13px;

      p {
        margin: 0 0 10px;
      }

      .el-button {
        border: 0;
        background: linear-gradient(90deg, #c94225, #7255e9);
      }
    }

    .session {
      display: flex;
      padding: 12px;
      margin-bottom: 4px;
      border-radius: 14px;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        background: #fff9fc;
      }

      &.active {
        background: #f8f6fb;
      }

      .av {
        width: 44px;
        height: 44px;
        margin-right: 10px;
        flex-shrink: 0;
        border-radius: 50%;
        background: linear-gradient(135deg, #eeeafe, #d8cdf9);
      }

      .info {
        flex: 1;
        min-width: 0;

        .top {
          display: flex;
          align-items: center;
          margin-bottom: 4px;

          b {
            margin-right: 6px;
            font-size: 14px;
          }

          .tag {
            padding: 1px 6px;
            border-radius: 8px;
            color: #7255e9;
            font-size: 10px;
            background: #f1edff;

            &.off {
              color: #999;
              background: #f5f5f5;
            }
          }

          em {
            margin-left: auto;
            color: #ccc;
            font-size: 11px;
            font-style: normal;
          }
        }

        p {
          margin: 0;
          color: #999;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .manage {
      margin-top: auto;
      width: 100%;
      color: #7255e9;
      border-color: #ded6ff;
    }
  }

  .main-chat {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background: #fff;
    overflow: hidden;

    &.empty-chat {
      align-items: center;
      justify-content: center;
      padding: 24px;

      .empty-chat-inner {
        max-width: 360px;
        text-align: center;

        i {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 72px;
          border-radius: 50%;
          color: #7255e9;
          font-size: 34px;
          background: #f7f4ff;
        }

        h2 {
          margin: 18px 0 8px;
          font-size: 24px;
          color: #1a1a1a;
        }

        p {
          margin: 0 0 18px;
          color: #999;
          font-size: 14px;
          line-height: 1.7;
        }

        .empty-actions {
          display: flex;
          justify-content: center;
          gap: 10px;

          .el-button--primary {
            border: 0;
            background: linear-gradient(90deg, #c94225, #7255e9);
          }
        }
      }
    }

    .chat-head {
      display: flex;
      align-items: center;
      padding: 16px 20px;
      border-bottom: 1px solid #f4f1f7;

      .av {
        width: 48px;
        height: 48px;
        margin-right: 12px;
        border-radius: 50%;
        background: linear-gradient(135deg, #eeeafe, #d8cdf9);
      }

      .meta {
        flex: 1;

        .name-row {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 4px;

          b {
            font-size: 16px;
          }

          .default-tag {
            padding: 2px 8px;
            border-radius: 8px;
            color: #7255e9;
            font-size: 11px;
            background: #f1edff;
          }

          .online {
            color: #52c41a;
            font-size: 12px;
          }
        }

        p {
          margin: 0;
          color: #999;
          font-size: 12px;
        }
      }

      .tools {
        display: flex;
        align-items: center;
        gap: 16px;
        color: #bbb;
        font-size: 18px;

        i {
          cursor: pointer;
          transition: color 0.2s;

          &:hover,
          &.active {
            color: #7255e9;
          }
        }

        .wx-push {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 5px 10px;
          border-radius: 16px;
          color: #999;
          font-size: 12px;
          background: #f5f5f5;
          cursor: pointer;

          i {
            font-size: 14px;
          }

          &.on {
            color: #07c160;
            background: #e8f9ef;
          }
        }
      }
    }

    .session-tabs {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      padding: 8px 20px;
      border-bottom: 1px solid #f4f1f7;

      .session-tab {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 12px;
        border: 1px solid #e8e3ed;
        border-radius: 14px;
        color: #888;
        font-size: 12px;
        cursor: pointer;
        transition: 0.2s;

        &:hover {
          color: #7255e9;
          border-color: #ded6ff;
        }

        &.on {
          color: #7255e9;
          border-color: #ded6ff;
          background: #f8f6fb;
        }

        &.add {
          border-style: dashed;
          color: #bbb;
        }

        i.el-icon-close {
          font-size: 11px;

          &:hover {
            color: #f56c6c;
          }
        }
      }

      &.single {
        border-bottom: 0;
        padding-bottom: 0;
      }
    }

    .msg-search {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 20px;
      border-bottom: 1px solid #f4f1f7;

      .el-input {
        flex: 1;
      }

      .cnt {
        color: #bbb;
        font-size: 12px;
        white-space: nowrap;
      }
    }

    .messages {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      // background: #fcfafb url("@/assert/chat.png") right 16px bottom 10px / 180px no-repeat;

      .time {
        margin-bottom: 16px;
        text-align: center;
        color: #ccc;
        font-size: 12px;
      }

      .empty-msg {
        padding: 40px 0;
        text-align: center;
        color: #ccc;
        font-size: 13px;
      }

      .row {
        display: flex;
        align-items: flex-end;
        margin-bottom: 14px;

        .av {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center top;
          background: linear-gradient(135deg, #eeeafe, #d8cdf9);
        }

        .user-av {
          color: #fff;
          font-size: 13px;
          font-weight: 700;
          background: linear-gradient(135deg, #c94225, #7255e9);
        }

        .msg-wrap {
          max-width: 65%;
          margin: 0 10px;

          .actor {
            display: block;
            margin-bottom: 4px;
            color: #ff9800;
            font-size: 11px;

            i {
              margin-right: 2px;
            }
          }

        }

        .bubble {
          padding: 12px 16px;
          border-radius: 16px;
          font-size: 14px;
          line-height: 1.5;

          i {
            margin-right: 4px;
          }
        }

        &.ai .bubble {
          background: #fff;
          color: #444;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        }

        &.takeover .bubble {
          color: #fff;
          background: linear-gradient(90deg, #ffb04d, #ff9800);
        }

        &.user {
          justify-content: flex-end;

          .bubble {
            color: #fff;
            background: linear-gradient(90deg, #c94225, #7255e9);
          }
        }
      }

      .typing {
        color: #c8bdf6;
        font-size: 12px;
      }
    }

    .input-area {
      position: relative;
      padding: 12px 20px 16px;
      border-top: 1px solid #f4f1f7;

      .toolbar {
        display: flex;
        gap: 14px;
        margin-bottom: 8px;
        color: #ccc;
        font-size: 18px;
      }

      ::v-deep .el-textarea__inner {
        border: 0;
        padding: 0;
        box-shadow: none;
      }

      .send {
        position: absolute;
        right: 24px;
        bottom: 20px;
        border: 0;
        background: linear-gradient(90deg, #c94225, #7255e9);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    height: calc(100vh - 130px);

    .sessions {
      width: 100%;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      padding: 8px 10px;
      border-radius: 14px;
      overflow-x: auto;

      .search-row,
      .manage,
      .empty-sess .el-button {
        display: none;
      }

      .session {
        flex-shrink: 0;
        padding: 4px;
        margin: 0 6px 0 0;

        .info {
          display: none;
        }

        .av {
          margin-right: 0;
        }

        &.active .av {
          outline: 2px solid #7255e9;
        }
      }
    }

    .main-chat {
      flex: 1;
      min-height: 0;

      .chat-head {
        padding: 10px 12px;

        .tools {
          gap: 10px;

          .wx-push span {
            display: none;
          }
        }
      }

      .messages {
        padding: 12px;

        .row .msg-wrap {
          max-width: 78%;
        }
      }

      .input-area {
        padding: 8px 12px 12px;
      }
    }

    .side-panel {
      display: none;
    }
  }

  .side-panel {
    width: 280px;
    flex-shrink: 0;
    padding: 18px;
    border-radius: 20px;
    background: #fff;
    overflow-y: auto;
    box-sizing: border-box;

    h3 {
      margin: 0 0 16px;
      color: #7255e9;
      font-size: 15px;
    }

    .stat {
      margin-bottom: 14px;

      label {
        display: block;
        margin-bottom: 6px;
        color: #999;
        font-size: 12px;
      }

      span {
        color: #7255e9;
        font-size: 12px;
      }
    }

    .stat-row {
      display: flex;
      gap: 12px;
      margin-bottom: 18px;

      div {
        flex: 1;
        padding: 12px;
        border-radius: 12px;
        background: #fafafa;
        text-align: center;

        b {
          display: block;
          margin-bottom: 4px;
          font-size: 16px;
          color: #333;
        }

        small {
          color: #bbb;
          font-size: 11px;
        }
      }
    }

    .block {
      margin-bottom: 18px;

      .block-head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        color: #333;
        font-size: 13px;
        font-weight: 600;

        a {
          color: #7255e9;
          font-size: 12px;
          font-weight: 400;
          text-decoration: none;
        }
      }

      .memory {
        display: flex;
        margin-bottom: 10px;

        .dot {
          width: 8px;
          height: 8px;
          margin: 6px 10px 0 0;
          border-radius: 50%;
          background: #7255e9;
        }

        b {
          display: block;
          font-size: 12px;
          color: #7255e9;
        }

        p {
          margin: 2px 0 0;
          color: #999;
          font-size: 12px;
        }
      }

      .now-state {
        padding: 11px 12px;
        border-radius: 12px;
        background: #fafafa;

        p {
          margin: 0;
          color: #666;
          font-size: 13px;
          line-height: 1.75;
          overflow-wrap: anywhere;
        }
      }

      .quick-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;

        button {
          padding: 10px 8px;
          border: 1px solid #e8e3ed;
          border-radius: 12px;
          color: #666;
          font-size: 11px;
          cursor: pointer;
          background: #fafafa;
          transition: 0.2s;

          &:hover {
            color: #7255e9;
            border-color: #ded6ff;
            background: #f8f6fb;
          }
        }
      }
    }
  }
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 130px;
  border: 1px dashed #ded6ff;
  border-radius: 14px;
  color: #c8bdf6;
  font-size: 13px;
  cursor: pointer;
  background: #fff8fc;

  i {
    margin-bottom: 8px;
    font-size: 30px;
  }
}

.voice-box {
  text-align: center;
  color: #7255e9;

  > i {
    font-size: 40px;
  }

  p {
    margin: 8px 0 16px;
    color: #999;
    font-size: 13px;
  }

  .wave {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 40px;

    span {
      width: 4px;
      border-radius: 2px;
      background: #c8bdf6;
    }
  }
}

.voice-tip {
  margin: 10px 2px 0;
  color: #b9849c;
  font-size: 12px;
  line-height: 1.5;
}

.chat-upload {
  .el-upload-dragger {
    width: 100%;
  }
}

.bubble {
  &.has-image {
    padding: 8px;
    background: transparent !important;
  }

  .bubble-media {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .bubble-img {
    display: block;
    max-width: 220px;
    max-height: 260px;
    border-radius: 12px;
    object-fit: cover;
  }

  .bubble-text {
    margin-top: 8px;
    color: inherit;
    line-height: 1.5;
    white-space: pre-wrap;
  }
}
</style>

<style lang="scss">
.emoji-popover {
  border: 1px solid var(--xyo-line);
  border-radius: 14px;
  background: var(--xyo-surface-raised);
  box-shadow: var(--xyo-shadow-lg);

  .emoji-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 3px;
    max-width: 240px;

    .emoji {
      padding: 6px 4px;
      border-radius: 8px;
      font-size: 20px;
      text-align: center;
      cursor: pointer;
      transition: background-color 160ms ease, transform 160ms ease;

      &:hover {
        background: var(--xyo-accent-pale);
        transform: translateY(-1px);
      }
    }
  }
}
</style>

<style scoped lang="scss">
/* Warm, quiet conversation workspace. Business structure and interactions remain unchanged. */
.chat-page {
  display: grid;
  grid-template-columns: 228px minmax(430px, 1fr) 248px;
  gap: 12px;
  width: 100%;
  height: calc(100svh - 134px);
  min-height: 610px;
  overflow: hidden;
  color: var(--xyo-ink);

  .sessions,
  .main-chat,
  .side-panel {
    min-width: 0;
    border: 1px solid var(--xyo-line);
    border-radius: var(--xyo-radius-lg);
    background: var(--xyo-surface-raised);
    box-shadow: var(--xyo-shadow-sm);
  }

  .sessions {
    width: auto;
    padding: 12px 10px 10px;
    overflow: hidden;

    .search-row {
      gap: 7px;
      margin-bottom: 10px;
      padding: 0 2px;

      .el-input {
        min-width: 0;
      }

      ::v-deep .el-input__inner {
        height: 36px;
        padding-left: 31px;
        border-radius: 10px !important;
        background: var(--xyo-surface-muted) !important;
        font-size: 12px;
      }

      ::v-deep .el-input__prefix {
        left: 9px;
        color: var(--xyo-muted);
      }

      .el-button {
        width: 36px;
        min-height: 36px;
        flex: 0 0 36px;
      }
    }

    .empty-sess {
      margin: auto 0;
      padding: 32px 12px;
      color: var(--xyo-muted);
    }

    .session {
      position: relative;
      min-width: 0;
      margin: 0 0 3px;
      padding: 9px 8px;
      border: 1px solid transparent;
      border-radius: 12px;
      transition: border-color 180ms ease, background-color 180ms ease, transform 180ms ease;

      &::before {
        content: "";
        position: absolute;
        top: 11px;
        bottom: 11px;
        left: 0;
        width: 3px;
        border-radius: 0 4px 4px 0;
        background: transparent;
      }

      &:hover {
        border-color: #e8e3ed;
        background: #f8f6fb;
        transform: translateX(1px);
      }

      &.active {
        border-color: #d8cdf9;
        background: var(--xyo-accent-pale);

        &::before {
          background: var(--xyo-primary);
        }
      }

      .av {
        display: block;
        flex: 0 0 38px;
        width: 38px;
        height: 38px;
        aspect-ratio: 1;
        margin-right: 9px;
        border: 1px solid #e8e3ed;
        background: var(--xyo-surface-muted);
        object-fit: cover;
        object-position: center;
      }

      .info {
        min-width: 0;

        .top {
          min-width: 0;
          margin-bottom: 3px;

          b {
            max-width: 74px;
            margin-right: 5px;
            overflow: hidden;
            color: var(--xyo-ink-strong);
            font-size: 13px;
            font-weight: 700;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .tag {
            padding: 1px 6px;
            border: 1px solid #b9ddcf;
            border-radius: 999px;
            color: var(--xyo-success);
            background: var(--xyo-success-soft);

            &.off {
              border-color: var(--xyo-line);
              color: var(--xyo-muted);
              background: var(--xyo-surface-muted);
            }
          }

          em {
            color: #9b8d80;
            font-size: 10px;
          }
        }

        p {
          color: var(--xyo-muted);
          font-size: 11px;
          line-height: 1.4;
        }
      }
    }

    .manage {
      margin-top: auto;
      border-top-color: var(--xyo-line) !important;
      color: var(--xyo-primary) !important;
      background: transparent !important;
    }
  }

  .main-chat {
    width: auto;
    overflow: hidden;

    &.empty-chat {
      background:
        radial-gradient(circle at 50% 38%, rgba(253, 99, 40, 0.08), transparent 27%),
        var(--xyo-surface-raised);

      .empty-chat-inner {
        max-width: 390px;

        > i {
          width: 64px;
          height: 64px;
          border: 1px solid #e3d7ed;
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

        h2 {
          margin: 16px 0 7px;
          color: var(--xyo-ink-strong);
          font-size: 23px;
        }

        p {
          color: var(--xyo-muted);
        }
      }
    }

    .chat-head {
      min-height: 70px;
      padding: 12px 16px;
      border-bottom-color: var(--xyo-line);
      background: rgba(255, 255, 255, 0.94);

      .av {
        display: block;
        flex: 0 0 44px;
        width: 44px;
        height: 44px;
        aspect-ratio: 1;
        margin-right: 11px;
        border: 1px solid #e4deea;
        background: var(--xyo-surface-muted);
        object-fit: cover;
        object-position: center;
      }

      .meta {
        min-width: 0;

        .name-row {
          margin-bottom: 3px;

          b {
            color: var(--xyo-ink-strong);
            font-size: 15px;
            font-weight: 750;
          }

          .online {
            color: var(--xyo-success);
            font-size: 11px;
          }
        }

        p {
          overflow: hidden;
          color: var(--xyo-muted);
          font-size: 11px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .tools {
        gap: 6px;
        color: var(--xyo-muted);

        > i,
        .el-dropdown > i {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border: 1px solid transparent;
          border-radius: 10px;
          color: var(--xyo-muted);
          font-size: 17px;
          transition: color 170ms ease, border-color 170ms ease, background-color 170ms ease;

          &:hover,
          &.active {
            border-color: #d8cdf9;
            color: var(--xyo-primary);
            background: var(--xyo-accent-pale);
          }
        }

        .wx-push {
          min-height: 34px;
          padding: 4px 8px;
          border: 1px solid var(--xyo-line);
          border-radius: 10px;
          color: var(--xyo-muted);
          background: var(--xyo-surface-muted);

          i {
            color: var(--xyo-muted);
          }

          &.on {
            border-color: #b9ddcf;
            color: var(--xyo-success);
            background: var(--xyo-success-soft);

            i {
              color: var(--xyo-success);
            }
          }
        }
      }
    }

    .session-tabs {
      min-height: 42px;
      flex-wrap: nowrap;
      gap: 6px;
      padding: 7px 16px;
      overflow-x: auto;
      border-bottom-color: var(--xyo-line);
      background: #fbf5ec;
      scrollbar-width: thin;

      .session-tab {
        min-height: 27px;
        flex: 0 0 auto;
        padding: 4px 10px;
        border-color: var(--xyo-line);
        border-radius: 8px;
        color: var(--xyo-muted);
        background: rgba(255, 255, 255, 0.72);

        &:hover {
          border-color: #c8bdf6;
          color: var(--xyo-primary);
        }

        &.on {
          border-color: #c8bdf6;
          color: var(--xyo-primary);
          background: var(--xyo-accent-pale);
        }

        &.add {
          border-color: transparent;
          color: var(--xyo-primary);
          background: transparent;
        }
      }

      &.single {
        padding-bottom: 7px;
        border-bottom: 1px solid var(--xyo-line);
      }
    }

    .msg-search {
      padding: 7px 16px;
      border-bottom-color: var(--xyo-line);
      background: var(--xyo-surface-muted);

      .cnt {
        color: var(--xyo-muted);
      }
    }

    .messages {
      min-height: 0;
      padding: 22px clamp(16px, 2.2vw, 30px);
      overflow-x: hidden;
      background:
        radial-gradient(circle at 12% 6%, rgba(114, 85, 233, 0.055), transparent 24%),
        linear-gradient(180deg, #fbfafd 0%, #f4f1f7 100%);
      scrollbar-color: #d6c2ae transparent;
      scrollbar-width: thin;

      .empty-msg {
        padding-top: 54px;
        color: var(--xyo-muted);
      }

      .row {
        width: 100%;
        margin-bottom: 17px;
        animation: xyo-message-arrive 240ms cubic-bezier(0.22, 1, 0.36, 1) both;

        .av {
          width: 32px;
          height: 32px;
          border: 1px solid #e1dbe7;
          background: var(--xyo-surface-raised);
        }

        .user-av {
          border-color: #b9431e;
          color: #fff;
          font-size: 11px;
          background: var(--xyo-primary);
        }

        .msg-wrap {
          max-width: min(70%, 660px);
          margin: 0 9px;

          .actor {
            margin: 0 3px 5px;
            color: var(--xyo-warning);
          }
        }

        .bubble {
          padding: 10px 14px;
          border: 1px solid var(--xyo-line);
          border-radius: 15px 15px 15px 5px;
          color: var(--xyo-ink);
          background: var(--xyo-surface-raised);
          box-shadow: 0 5px 14px rgba(34, 28, 48, 0.045);
          font-size: 13.5px;
          line-height: 1.65;
          overflow-wrap: anywhere;
          word-break: break-word;
        }

        &.ai .bubble {
          border-color: var(--xyo-line);
          color: var(--xyo-ink);
          background: var(--xyo-surface-raised);
          box-shadow: 0 5px 14px rgba(34, 28, 48, 0.045);
        }

        .delivery-label {
          display: block;
          margin: 4px 3px 0;
          color: var(--xyo-muted);
          font-size: 10px;
        }

        &.system {
          justify-content: center;

          .msg-wrap {
            max-width: min(82%, 720px);
            text-align: center;
          }

          .actor {
            color: var(--xyo-muted);
          }

          .bubble {
            display: inline-block;
            border-color: var(--xyo-line);
            border-radius: 12px;
            color: var(--xyo-muted);
            background: rgba(255, 255, 255, 0.64);
            box-shadow: none;
            font-size: 12px;
          }
        }

        &.takeover .bubble {
          border-color: #e7cc9d;
          color: #70470e;
          background: var(--xyo-warning-soft);
          box-shadow: none;
        }

        &.user .bubble {
          border-color: var(--xyo-primary);
          border-radius: 15px 15px 5px 15px;
          color: #fff;
          background: var(--xyo-primary);
          box-shadow: 0 7px 18px rgba(166, 62, 24, 0.14);
        }
      }

      .typing {
        display: inline-flex;
        align-items: center;
        min-height: 28px;
        margin-left: 41px;
        padding: 5px 10px;
        border: 1px solid var(--xyo-line);
        border-radius: 10px;
        color: var(--xyo-muted);
        background: rgba(255, 255, 255, 0.78);
        font-size: 11px;
        animation: xyo-typing-pulse 1.8s ease-in-out infinite;
      }
    }

    .input-area {
      padding: 9px 16px 13px;
      border-top-color: var(--xyo-line);
      background: var(--xyo-surface-raised);

      .toolbar {
        gap: 5px;
        margin-bottom: 6px;
        color: var(--xyo-muted);

        > i,
        ::v-deep .el-popover__reference {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 28px;
          border-radius: 8px;
          color: var(--xyo-muted);
          font-size: 17px;
          transition: color 160ms ease, background-color 160ms ease;

          &:hover {
            color: var(--xyo-primary);
            background: var(--xyo-accent-pale);
          }
        }
      }

      ::v-deep .el-textarea__inner {
        min-height: 64px !important;
        padding: 11px 52px 11px 13px !important;
        border: 1px solid var(--xyo-line-strong) !important;
        border-radius: 13px !important;
        color: var(--xyo-ink-strong) !important;
        background: var(--xyo-surface-muted) !important;
        line-height: 1.55;

        &:focus {
          border-color: var(--xyo-accent) !important;
          background: #fff !important;
        }
      }

      .send {
        right: 25px;
        bottom: 23px;
        width: 38px;
        min-height: 38px;
        box-shadow: 0 8px 18px rgba(166, 62, 24, 0.19) !important;
      }
    }
  }

  .side-panel {
    width: auto;
    padding: 15px 15px 12px;
    overflow-x: hidden;
    overflow-y: auto;
    background: rgba(252, 251, 253, 0.76);
    scrollbar-width: thin;

    h3 {
      margin: 1px 0 15px;
      padding-bottom: 12px;
      border-bottom: 1px solid var(--xyo-line);
      color: var(--xyo-primary);
      font-size: 13px;
      font-weight: 750;
      letter-spacing: 0.02em;
    }

    .stat {
      margin-bottom: 15px;

      label {
        color: var(--xyo-muted);
      }

      span {
        color: var(--xyo-primary);
        font-size: 11px;
      }
    }

    .stat-row {
      gap: 8px;
      margin-bottom: 17px;

      div {
        padding: 10px 8px;
        border: 1px solid var(--xyo-line);
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.72);

        b {
          color: var(--xyo-ink-strong);
          font-size: 14px;
        }

        small {
          color: var(--xyo-muted);
        }
      }
    }

    .block {
      margin: 0;
      padding: 14px 0;
      border-top: 1px solid var(--xyo-line);

      .block-head {
        margin-bottom: 9px;
        color: var(--xyo-ink-strong);
        font-size: 12px;

        a {
          color: var(--xyo-primary);
          font-size: 11px;
        }
      }

      .memory {
        margin: 0;

        .dot {
          background: var(--xyo-primary);
        }

        p {
          color: var(--xyo-muted);
          line-height: 1.6;

          a {
            color: var(--xyo-primary);
          }
        }
      }

      .now-state {
        border: 1px solid var(--xyo-line);
        background: var(--xyo-surface-muted);

        p {
          color: var(--xyo-ink-soft);
        }
      }

      .quick-grid {
        gap: 6px;

        button {
          min-height: 38px;
          padding: 7px 6px;
          border-color: var(--xyo-line);
          border-radius: 9px;
          color: var(--xyo-ink-soft);
          background: rgba(255, 255, 255, 0.76);

          &:hover,
          &:focus-visible {
            border-color: #d7a98d;
            color: var(--xyo-primary);
            background: var(--xyo-accent-pale);
          }
        }
      }
    }
  }
}

.upload-box {
  border-color: #d6a88e;
  color: var(--xyo-primary);
  background: var(--xyo-accent-pale);
}

.voice-box {
  color: var(--xyo-primary);

  p {
    color: var(--xyo-muted);
  }

  .wave span {
    background: var(--xyo-accent);
  }
}

.voice-tip {
  color: var(--xyo-muted);
}

.bubble {
  .bubble-img {
    max-width: min(240px, 62vw);
    border: 1px solid var(--xyo-line);
    border-radius: 11px;
  }

  .bubble-text {
    margin-top: 6px;
  }
}

@keyframes xyo-message-arrive {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes xyo-typing-pulse {
  0%,
  100% {
    opacity: 0.64;
  }

  50% {
    opacity: 1;
  }
}

@media (max-width: 1320px) and (min-width: 1121px) {
  .chat-page {
    grid-template-columns: 208px minmax(360px, 1fr) 220px;
  }
}

@media (max-width: 1120px) and (min-width: 769px) {
  .chat-page {
    grid-template-columns: 210px minmax(0, 1fr);
    grid-template-rows: minmax(360px, 1fr) 170px;
    overflow: hidden;

    .side-panel {
      display: flex;
      width: auto;
      min-width: 0;
      grid-column: 1 / -1;
      grid-row: 2;
      flex-direction: row;
      gap: 10px;
      padding: 12px;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: thin;

      > h3,
      > .stat,
      > .stat-row,
      > .block {
        min-width: 180px;
        flex: 0 0 180px;
        margin: 0;
      }

      > h3 {
        min-width: 130px;
        flex-basis: 130px;
      }

      .quick-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    }
  }
}

@media (max-width: 768px) {
  .chat-page {
    display: flex;
    width: 100%;
    max-width: 100%;
    height: calc(100svh - 126px);
    min-height: 500px;
    gap: 7px;
    overflow: hidden;

    .sessions {
      width: 100%;
      min-width: 0;
      height: 54px;
      flex: 0 0 54px;
      padding: 5px 7px;
      border-radius: 13px;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      .session {
        width: 42px;
        min-width: 42px;
        height: 42px;
        flex: 0 0 42px;
        margin-right: 4px;
        padding: 2px;
        border: 0;
        border-radius: 50%;

        &::before {
          display: none;
        }

        &:hover {
          transform: none;
        }

        .av {
          flex-basis: 38px;
          width: 38px;
          height: 38px;
          margin: 0;
        }

        &.active {
          background: transparent;

          .av {
            border-color: var(--xyo-accent);
            outline: 2px solid rgba(114, 85, 233, 0.24);
            outline-offset: 1px;
          }
        }
      }
    }

    .main-chat {
      width: 100%;
      min-width: 0;
      min-height: 0;
      flex: 1 1 auto;
      border-radius: 14px;

      .chat-head {
        min-height: 58px;
        padding: 8px 9px;

        .av {
          width: 38px;
          height: 38px;
          margin-right: 8px;
        }

        .meta {
          .name-row {
            gap: 5px;

            b {
              max-width: 88px;
              overflow: hidden;
              font-size: 13px;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .online {
              font-size: 9px;
              white-space: nowrap;
            }
          }

          p {
            display: none;
          }
        }

        .tools {
          gap: 2px;

          > i,
          .el-dropdown > i {
            width: 30px;
            height: 30px;
            font-size: 15px;
          }

          .wx-push {
            min-height: 30px;
            gap: 3px;
            padding: 2px 5px;
            border-radius: 9px;

            span {
              display: none;
            }

            i {
              margin: 0;
              font-size: 13px;
            }
          }
        }
      }

      .session-tabs {
        min-height: 36px;
        padding: 5px 9px;

        .session-tab {
          min-height: 25px;
          padding: 3px 8px;
          font-size: 10.5px;
        }
      }

      .msg-search {
        padding: 5px 9px;

        ::v-deep .el-input__inner {
          height: 34px;
        }
      }

      .messages {
        min-height: 0;
        padding: 13px 9px;

        .row {
          min-width: 0;
          margin-bottom: 13px;

          .av {
            width: 29px;
            height: 29px;
          }

          .msg-wrap {
            max-width: calc(100% - 42px);
            margin: 0 6px;
          }

          .bubble {
            max-width: 100%;
            padding: 9px 11px;
            font-size: 13px;
          }
        }

        .typing {
          margin-left: 35px;
        }
      }

      .input-area {
        padding: 6px 9px 9px;

        .toolbar {
          margin-bottom: 3px;
        }

        ::v-deep .el-textarea__inner {
          min-height: 52px !important;
          padding: 8px 46px 8px 10px !important;
          font-size: 13px;
        }

        .send {
          right: 15px;
          bottom: 14px;
          width: 34px;
          min-height: 34px;
        }
      }
    }
  }
}

@media (max-width: 420px) {
  .chat-page .main-chat .chat-head {
    .meta .name-row .online {
      display: none;
    }

    .tools .wx-push > i {
      display: none;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .chat-page .messages .row,
  .chat-page .messages .typing {
    animation: none;
  }
}

.history-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  gap: 8px;
  color: var(--xyo-muted, #8c8493);
  font-size: 13px;

  i {
    color: var(--xyo-primary, #c94225);
    font-size: 18px;
  }
}
</style>
